<template>
  <div v-show="visible">
    <el-dialog title="预约发布" :close-on-click-modal="false" element-loading-background="rgba(255, 255,255,0.7)" :visible.sync="visible" :before-close="dialogClose" width="410px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item prop="releaseReportType" label="发布报告类型">
              <el-radio-group v-model="form.releaseReportType">
                  <el-radio :label="1">综合素养</el-radio>
                  <el-radio :label="2">学科成绩</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item prop="reservationReleaseDatetime" label="预约日期时间">
              <el-date-picker style="width: 220px"
                  v-model="form.reservationReleaseDatetime"
                  type="datetime"
                  placeholder="选择日期时间"
                  :disabled-date="disabledDate"
                  :disabled-time="disabledTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :editable="false">
              </el-date-picker>
          </el-form-item>
      </el-form> 
      <div style='margin: 5px 0 10px 0; color:#E6A23C; font-size:13px; text-align: left;'>
        温馨提示：班主任可选“综合素养”或“学科成绩”类型的报告发布给学生家长，默认为“综合素养”报告。发布后不能修改，需删除重新上传模版生成报告后发布。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger"  @click="cancelReservation()">取消预约</el-button>
        <el-button type="primary" @click="reservationRelease()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../common/http";

export default {
  data() {
    return {
      visible: false,
      form: {
        id: '',
        reservationReleaseDatetime: '',
        releaseReportType: 1
      },
      rules: {
        reservationReleaseDatetime: [
          { required: true, message: "请输入预约日期时间", trigger: "blur" },
        ],
      }
    };
  },
  components: {
  },
  created: function () { },
  mounted: function () { },
  methods: {
    init(data) {
      this.visible = true
      // 参数初始
      this.form.id = data.id
      this.form.reservationReleaseDatetime = data.reservationReleaseDatetime
      this.form.releaseReportType = Number(data.releaseReportType) || 1

    },
    // 禁用今天之前的日期
    disabledDate(time) {
      return time.getTime() < Date.now() - 1000; 
    },
    // 禁用当前日期的过去时间
    disabledTime(date) {
      const now = new Date();
      if (
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate()
      ) {
        return {
          disabledHours: () => {
            let hours = [];
            for (let i = 0; i < now.getHours(); i++) {
              hours.push(i);
            }
            return hours;
          },
          disabledMinutes: () => {
            let minutes = [];
            if (date.getHours() === now.getHours()) {
              for (let i = 0; i < now.getMinutes(); i++) {
                minutes.push(i);
              }
            }
            return minutes;
          },
          disabledSeconds: () => {
            let seconds = [];
            if (
              date.getHours() === now.getHours() &&
              date.getMinutes() === now.getMinutes()
            ) {
              for (let i = 0; i < now.getSeconds(); i++) {
                seconds.push(i);
              }
            }
            return seconds;
          }
        };
      }
      return {};
    },
    cancelReservation(){
        let url = this.studentComprehensiveReportCancelReservationUrl;
        let data = {
          id: this.form.id
        };

        this.apiPost(url, data).then((res) => {
            if (res.status === 200) {
              this.$commonFn.showTip(res.message, 1)
              this.visible = false
              this.$parent.getData()
            } else {
              this.$commonFn.showTip(res.message, 3)
            }
          },(err) => {
            console.log(err)
          }
        )
    },
    reservationRelease(){
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = this.studentComprehensiveReportReservationReleaseUrl;
          let data = {
            id: this.form.id,
            reservationReleaseDatetime: this.form.reservationReleaseDatetime,
            releaseReportType: this.form.releaseReportType
          };

          this.apiPost(url, data).then((res) => {
              if (res.status === 200) {
                this.$commonFn.showTip(res.message, 1)
                this.visible = false
                this.$parent.getData()
              } else {
                this.$commonFn.showTip(res.message, 3)
              }
            },(err) => {
              console.log(err)
            }
          )
        }
      });
    },
    dialogClose(done) {
      done()
      this.$reload
    }
  },
  mixins: [http],
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/ReservationReleaseDialog.vue